import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { showToaster } from "../../toster";
import MaskedInput from "react-text-mask";


function ClaimOtp({ MobileNo, EmailID, PolicyNo }) {
    const navigate = useNavigate();
    const [otp, setOtp] = useState(""); // Single state for OTP
    const [btnVal, setBtnVal] = useState("Continue");
    const [error, setError] = useState("");
   
    useEffect(() => {
        setOtp(""); // Reset OTP input on component mount
    }, []);

    const handleInputChange = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numeric input
        if (value.length <= 5) {
            setOtp(value);
        }
    };

    const opentell = async () => {
        if (otp.length !== 5) {
            setError("Please enter a 5-digit OTP.");
            return;
        }

        setBtnVal("Wait....");
        const OTPV = {
            OTP: otp,
            MobileNo,
            EmailId: null,
            PolicyNo: PolicyNo
        };

        try {
            const res = await axios.post(
                "https://crmapi.smcinsurance.com:8081/api/External/RetailCustomerOTPValidation",
                OTPV,
                {
                    headers: {
                        Token: "d41d8cd98f00b204e9800998ecf8427e",
                        "Content-Type": "application/json"
                    }
                }
            );

            if (res.status === 200 && res.data?.status === true) {
                const redirectPath = res.data.data.length === 1 && "/claim-submit";
                navigate(redirectPath, {
                    state: { policyData: res.data.data }
                });
                showToaster({
                    message: "Claim your policy.",
                    type: "success",
                });
            } else {
                showToaster({
                    message: "Unable to procced!",
                    type: "error",
                });
            }
        } catch (err) {
            console.error("API Error:", err);
        }
    };

    return (
        <div className="otpclaim">
            <div className="p-2 text-left">
                <div className="otp mt-3 text-left">
                    <h4>OTP Verification</h4>
                    <div className="login-FILD">
                        <div className="input-wrap">
                            <MaskedInput
                                mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} // OTP mask for 5 digits
                                guide={false}
                                showMask={false}
                                className="textdemo"
                                placeholder=" "
                                value={otp}
                                onChange={handleInputChange}
                            />
                            <label className="demo-label" htmlFor="ForUp1">
                                Verify OTP
                            </label>
                        </div>
                    </div>
                    <p className="errors-msg">{error}</p>

                    <button className="newcRT d-block w-100" onClick={opentell}>
                        {btnVal} <i className="arroin right"></i>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ClaimOtp;
